import get from 'lodash/get';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import compose from 'recompose/compose';
import withHandlers from 'recompose/withHandlers';
import {formDataManager} from 'hoc/formDataManager';
import AwardPointsModal from './AwardPointsModal';
import config from './awardPointsFormConfig';
import {endAwardPointsAction, submitAwardPointsAction} from '../../../actions';

const mapStateToProps = state => {
  const {awardingPoints, awardPointsSubmitted, awardPointsError, currentUserId, currentUser} = state.userManagement;
  return {
    userId: currentUserId,
    email: get(currentUser, 'email', null),
    modalOpen: awardingPoints,
    awarding: awardPointsSubmitted,
    error: awardPointsError
  };
};

const mapDispatchToProps = dispatch => bindActionCreators({
  awardPoints: submitAwardPointsAction,
  handleClose: endAwardPointsAction
}, dispatch);

const AwardPointsModalContainer = compose(
  connect(mapStateToProps, mapDispatchToProps),
  withHandlers({
    onSaveData: props => data => props.awardPoints(Number(props.userId), Number(data.amount), data.reason)
  }),
  formDataManager({amount: '', reason: ''}, config)
)(AwardPointsModal);

export default AwardPointsModalContainer;



// WEBPACK FOOTER //
// ./public/pages/UserManagement/UserDetailPage/modals/AwardPointsModal/AwardPointsModalContainer.js